export default __webpack_public_path__ + "static/media/facebook-blue.1be6ceae.svg";